export enum ConfigurationsActionTypes {
    GET_CONFIGURATIONS_LIST = "[App Action][Configurations] GET CONFIGURATIONS LIST",
    GET_CONFIGURATIONS_LIST_SUCCESS = "[App Action][Configurations] GET CONFIGURATIONS LIST SUCCESS",
    GET_CONFIGURATIONS_LIST_FAIL = "[App Action][Configurations] GET CONFIGURATIONS LIST FAIL",

    GET_LATEST_SCHEMA = "[App Action][Configurations] GET LATEST SCHEMA",
    GET_LATEST_SCHEMA_SUCCESS = "[App Action][Configurations] GET LATEST SCHEMA SUCCESS",
    GET_LATEST_SCHEMA_FAIL = "[App Action][Configurations] GET LATEST SCHEMA FAIL",

    GET_CONFIGURATION = "[App Action][Configurations] GET CONFIGURATION",
    GET_CONFIGURATION_SUCCESS = "[App Action][Configurations] GET CONFIGURATION SUCCESS",
    GET_CONFIGURATION_FAIL = "[App Action][Configurations] GET CONFIGURATION FAIL",

    CLEAR_CONFIGURATION = "[App Action][Configurations] CLEAR CONFIGURATION",
    CLEAR_CONFIGURATION_STATE = "[App Action][Configurations] CLEAR CONFIGURATION STATE",

    UPDATE_BASIC_CONFIG = "[App Action][Configurations] UPDATE BASIC CONFIG",
    UPDATE_SETTINGS_CONFIG = "[App Action][Configurations] UPDATE SETTINGS CONFIG",
    UPDATE_ACCOUNTING_CONFIG = "[App Action][Configurations] UPDATE ACCOUNTING CONFIG",
    UPDATE_GROUPS_CONFIG = "[App Action][Configurations] UPDATE GROUPS CONFIG",
    UPDATE_GROUPS_CONFIG_EMPTY = "[App Action][Configurations] UPDATE GROUPS CONFIG EMTPY",
    UPDATE_PROGRESSIVES_CONFIG = "[App Action][Configurations] UPDATE PROGRESSIVES CONFIG",
    UPDATE_SPECIAL_PRIZES_CONFIG = "[App Action][Configurations] UPDATE SPECIAL PRIZES CONFIG",
    UPDATE_GLOBAL_JACKPOT_CONFIG = "[App Action][Configurations] UPDATE GLOBAL JACKPOT CONFIG",
    UPDATE_SOUNDS_CONFIG = "[App Action][Configurations] UPDATE SOUNDS CONFIG",
    UPDATE_RTP_PROFILES_CONFIG = "[App Action][Configurations] UPDATE RTP PROFILES CONFIG",
    UPDATE_GROUPS_BASED_ON_GAME_TYPES = "[App Action][Configurations] UPDATE GROUPS BASED ON GAME TYPES",
    UPDATE_SPECIAL_PRIZES_BASED_ON_BINGO_SETTINGS = "[App Action][Configurations] UPDATE SPECIAL PRIZES BASED ON BINGO SETTINGS",
    UPDATE_MAILING_CONFIG = "[App Action][Configurations] UPDATE MAILING CONFIG",
    UPDATE_MAIL_SENDER_CONFIG = "[App Action][Configurations] UPDATE MAIL SENDER CONFIG",
    UPDATE_MEGAPOT_CONFIG = "[App Action][Configurations] UPDATE MEGAPOT CONFIG",

    GET_HALL_BASIC_INFO = "[App Action][Configurations] GET HALL BASIC INFO",
    GET_HALL_BASIC_INFO_SUCCESS = "[App Action][Configurations] GET HALL BASIC INFO SUCCESS",
    GET_HALL_BASIC_INFO_FAIL = "[App Action][Configurations] GET HALL BASIC INFO FAIL",

    CREATE_CONFIGURATION = "[App Action][Configuration] CREATE CONFIGURATION",
    CREATE_CONFIGURATION_SUCCESS = "[App Action][Configuration] CREATE CONFIGURATION SUCCESS",
    CREATE_CONFIGURATION_FAIL = "[App Action][Configuration] CREATE CONFIGURATION FAIL",

    GET_PROGRESSIVES_RULES = "[App Action][Configuration] GET PROGRESSIVES RULES",
    GET_PROGRESSIVES_RULES_SUCCESS = "[App Action][Configuration] GET PROGRESSIVES RULES SUCCESS",
    GET_PROGRESSIVES_RULES_FAIL = "[App Action][Configuration] GET PROGRESSIVES RULES FAIL",

    EDIT_CONFIGURATION = "[App Action][Configuration] EDIT CONFIGURATION",
    EDIT_CONFIGURATION_SUCCESS = "[App Action][Configuration] EDIT CONFIGURATION SUCCESS",
    EDIT_CONFIGURATION_FAIL = "[App Action][Configuration] EDIT CONFIGURATION FAIL",

    GET_DENOMINATIONS = "[App Action][Denominations] GET DENOMINATIONS",
    GET_DENOMINATIONS_SUCCESS = "[App Action][Denominations] GET DENOMINATIONS SUCCESS",
    GET_DENOMINATIONS_FAIL = "[App Action][Denominations] GET DENOMINATIONS FAIL",

    GET_GAME_INSTANCES = "[App Action][Configurations] GET GAME INSTANCES",
    GET_GAME_INSTANCES_SUCCESS = "[App Action][Configurations] GET GAME INSTANCES SUCCESS",
    GET_GAME_INSTANCES_FAIL = "[App Action][Configurations] GET GAME INSTANCES FAIL",

    GET_GAME_BUNDLES = "[App Action][Configurations] GET GAME BUNDLES",
    GET_GAME_BUNDLES_SUCCESS = "[App Action][Configurations] GET GAME BUNDLES SUCCESS",
    GET_GAME_BUNDLES_FAIL = "[App Action][Configurations] GET GAME BUNDLES FAIL",

    SELECT_GROUP_TYPE = "[App Action][Configurations] SELECT GROUP TYPE",
    CLEAN_GROUP_TYPES = "[App Action][Configurations] CLEAN GROUP TYPES IN USE",

    UPDATE_NECESSARY_VALIDS = "[App Action][Configurations] UPDATE NECESSARY VALIDS",

    CLEAR_SCHEMA = "[App Action][Configurations] CLEAR SCHEMA",

    GET_DECIBELS = "[App Action][Sounds] GET DECIBELS",
    GET_DECIBELS_SUCCESS = "[App Action][Sounds] GET DECIBELS SUCCESS",
    GET_DECIBELS_FAIL = "[App Action][Sounds] GET DECIBELS FAIL",

    GET_PERCENTAGE = "[App Action][Sounds] GET PERCENTAGE",
    GET_PERCENTAGE_SUCCESS = "[App Action][Sounds] GET PERCENTAGE SUCCESS",
    GET_PERCENTAGE_FAIL = "[App Action][Sounds] GET PERCENTAGE FAIL",

    GET_SOUNDS_SERVER = "[App Action][Sounds] GET SOUNDS SERVER",
    GET_SOUNDS_SERVER_FAIL = "[App Action][Sounds] GET SOUNDS SERVER FAIL",

    GET_SOUNDS_GROUPS = "[App Action][Sounds] GET SOUNDS GROUPS",
    GET_SOUNDS_GROUPS_SUCCESS = "[App Action][Sounds] GET SOUNDS GROUPS SUCCESS",
    GET_SOUNDS_GROUPS_FAIL = "[App Action][Sounds] GET SOUNDS GROUPS FAIL",

    GET_SOUNDS = "[App Action][Sounds] GET SOUNDS",
    GET_SOUNDS_SUCCESS = "[App Action][Sounds] GET SOUNDS SUCCESS",
    GET_SOUNDS_FAIL = "[App Action][Sounds] GET SOUNDS FAIL",

    REORDER_SOUNDS = "[App Action][Sounds] REORDER SOUNDS",
    REORDER_SOUNDS_SUCCESS = "[App Action][Sounds] REORDER SOUNDS SUCCESS",

    UPDATE_SOUND_SETTINGS_LEVEL = "[App Action][Sounds] UPDATE SOUND SETTINGS LEVEL",
    UPDATE_SOUND_SETTINGS_SUB_LEVEL = "[App Action][Sounds] UPDATE SOUND SETTINGS SUB LEVEL",

    UPDATE_SOUND_SETTINGS_BULK = "[App Action][Sounds] UPDATE SOUND SETTINGS BULK",

    GET_RTP_PROFILES = "[App Action][RTP Profiles] GET RTP PROFILES",
    GET_RTP_PROFILES_SUCCESS = "[App Action][RTP Profiles] GET RTP PROFILES SUCCESS",
    GET_RTP_PROFILES_FAIL = "[App Action][RTP Profiles] GET RTP PROFILES FAIL",
    REORDER_RTP_PROFILES = "[App Action][RTP Profiles] REORDER RTP PROFILES",
    REORDER_RTP_PROFILES_SUCCESS = "[App Action][RTP Profiles] REORDER RTP PROFILES SUCCESS",
    UPDATE_RTP_PROFILE = "[App Action][RTP Profiles] UPDATE RTP PROFILE",
    SET_PREVIOUS_RTP_DEFAULT_PROFILE = "[App Action][RTP Profiles] SET PREVIOUS RTP DEFAULT PROFILE",

    CONFIGURATION_VISITED_EDIT_MODE = "[App Action][Configurations] CONFIGURATION VISITED EDIT MODE",
    VISIT_CONFIG_SECTION = "[App Action][Configurations] VISIT CONFIG SECTION",
    CLEAR_VALID_PROG_SECTION = "[App Action][Configurations] CLEAR VALID PROG SECTION",
    CLEAR_VALID_SPECIAL_SECTION = "[App Action][Configurations] CLEAR VALID SPECIAL SECTION",

    SET_UPLOAD_CONFIGURATION = "[App Action][Configurations] SET UPLOAD CONFIGURATION",

    GET_REGIONS = "[App Action][Configurations] GET REGIONS",
    GET_REGIONS_SUCCESS = "[App Action][Configurations] GET REGIONS SUCCESS",
    GET_REGIONS_FAIL = "[App Action][Configurations] GET REGIONS FAIL",

    GET_MAILING_LISTS = "[App Action][Mailing] GET MAILING LISTS",
    GET_MAILING_LISTS_SUCCESS = "[App Action][Mailing] GET MAILING LISTS SUCCESS",
    GET_MAILING_LISTS_FAIL = "[App Action][Mailing] GET MAILING LISTS FAIL",
    
    GET_CURRENCIES = "[App Action][Currencies] GET CURRENCIES",
    GET_CURRENCIES_SUCCESS = "[App Action][Currencies] GET CURRENCIES SUCCESS",
    GET_CURRENCIES_FAIL = "[App Action][Currencies] GET CURRENCIES FAIL",

    GET_PRODUCTION_INFO = "[App Action][Halls] GET PRODUCTION INFO",
    GET_PRODUCTION_INFO_SUCCESS = "[App Action][Halls] GET PRODUCTION INFO SUCCESS",
    GET_PRODUCTION_INFO_FAIL = "[App Action][Halls] GET PRODUCTION INFO FAIL",

    GET_MEGAPOT_SERVER_LIST = "[App Action][Megapot] GET MEGAPOT SERVER LIST",
    GET_MEGAPOT_SERVER_LIST_SUCCESS = "[App Action][Megapot] GET MEGAPOT SERVER LIST SUCCESS",
    GET_MEGAPOT_SERVER_LIST_FAIL = "[App Action][Megapot] GET MEGAPOT SERVER LIST FAIL",

    GET_MEGAPOT_PROVIDERS_LIST = "[App Action][Megapot] GET MEGAPOT PROVIDERS LIST",
    GET_MEGAPOT_PROVIDERS_LIST_SUCCESS = "[App Action][Megapot] GET MEGAPOT PROVIDERS LIST SUCCESS",
    GET_MEGAPOT_PROVIDERS_LIST_FAIL = "[App Action][Megapot] GET MEGAPOT PROVIDERS LIST FAIL",

}
